/**
 * Admin Dashboard latest user UI
 */
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import {
  Card,
  CardHeader,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  CardContent,
  TableRow,
  TableCell,
  useMediaQuery,
  Box,
} from '@mui/material';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppBadIcon from '@mui/icons-material/GppBad';
import CampaignIcon from '@mui/icons-material/Campaign';
import API from '../../api';
import { HttpErrorHandler, ErrorUI } from '../../utils/ErrorHandler';
import { EmptyPageUI, LoadingUI } from '../../utils/LayoutStyles';

import { MembershipCardIcon } from '../../utils/Common';

/**
 * @returns recently registered user list
 */
export default function AppLastUsers() {
  const is600Screen = useMediaQuery('(min-width: 600px)');
  const [users, setUsers] = useState([]);
  const [userTaken, setUserTaken] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Get recent user list api
  useEffect(() => {
    setErrorMessage('');
    API.get('/users')
      .then((response) => {
        setUsers(response.data.data);
        setUserTaken(true);
      })
      .catch((error) => {
        setUserTaken(true);
        HttpErrorHandler(error, setErrorMessage);
      });
  }, []);

  return (
    <Card
      sx={{
        height: is600Screen ? '460px' : 'auto',
      }}
    >
      <CardHeader title="Ultimi Iscritti" />
      {userTaken ? (
        <CardContent>
          {users.length !== 0 && errorMessage?.length === 0 ? (
            <TableContainer>
              <Table size="small" aria-label="Roles table">
                <TableHead>
                  <TableRow>
                    <TableCell>Nome Utente</TableCell>
                    <TableCell>Codice Fiscale</TableCell>
                    <TableCell>Entità Master</TableCell>
                    {is600Screen && (
                      <>
                        <TableCell align="center">Data di Nascita</TableCell>
                        <TableCell align="center">Tesserato</TableCell>
                        <TableCell align="center">Verificato</TableCell>
                        <TableCell align="center">Comunicazioni</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                {/* TableBody */}
                <TableBody>
                  {users
                    .slice()
                    .sort((a, b) => (a.created_at > b.created_at ? -1 : 1))
                    .slice(0, 5)
                    .map((user) => (
                      <TableRow hover key={user.id}>
                        <TableCell>
                          {user.name_alias
                            ? `${user.name_alias} [${user.name} ${user.surname}]`
                            : `${user.name} ${user.surname}`}
                        </TableCell>
                        <TableCell>{user.fiscal_code}</TableCell>
                        <TableCell>{user.master_entity[0].name}</TableCell>
                        {is600Screen && (
                          <>
                            <TableCell align="center">{dayjs(user.birth_date).format('DD/MM/YYYY')}</TableCell>
                            <TableCell align="center">
                              <MembershipCardIcon data={user} />
                            </TableCell>
                            <TableCell align="center">
                              {user.verified === 1 ? (
                                <GppGoodIcon sx={{ color: '#47ba25', fontSize: '1.8em' }} />
                              ) : (
                                <GppBadIcon sx={{ color: 'red', fontSize: '1.8em' }} />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <CampaignIcon
                                sx={{ color: user.allow_news === 1 ? '#47ba25' : 'gray', fontSize: '1.8em' }}
                              />
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : errorMessage?.length !== 0 ? (
            ErrorUI(errorMessage)
          ) : (
            // empty user lists UI message
            EmptyPageUI('Nessun untente trovato')
          )}
        </CardContent>
      ) : (
        <CardContent>{LoadingUI()}</CardContent>
      )}
    </Card>
  );
}
